import { DocumentsOfflineService } from '~/sqlite/services/documents';

export class DocumentLocalDataSource extends DocumentsOfflineService {}

export const documentLocal = new DocumentLocalDataSource();
